<template>
  <div class="app-container xmzk xmzk_z">
    <div class="middle">
      <div class="project-select card">
        <div class="card-header">
          <div class="card-title"><div>项目筛选</div></div>
          <div class="card-more">
            <el-date-picker
              v-model="xmSeleltParams.year"
              type="year"
              size="mini"
              placeholder="选择年"
              style="width: 100px; font-size: 13px"
              @change="handleChangeYear"
              :clearable="false"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="content">
          <div>
            <el-input
              placeholder="请输入关键字"
              v-model="filterText"
              class="input-with-select"
              size="small"
              style="width: 100%; margin-bottom: 15px"
              maxlength="50"
            >
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </div>
          <div>
            <el-tree
              :data="xmList"
              :props="defaultProps"
              :highlight-current="true"
              check-on-click-node
              :filter-node-method="filterNode"
              @node-click="handleNodeClick"
              ref="tree"
              accordion
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <div v-if="data.bmmc" style="color: #000; font-weight: 700">
                  <img src="@/img/tree_icon.png" width="14" alt="" />
                  <span> {{ node.label }} </span>
                </div>
                <div v-else class="tree_child">
                  <img src="@/img/tree_child_icon.png" width="14" alt="" />
                  <span> {{ node.label }} </span>
                </div>
              </span>
            </el-tree>
          </div>
        </div>
      </div>
      <div class="result card">
        <div class="project-info card">
          <!-- <div class="card-header">
              <div class="card-title"><div>项目信息</div></div>
            </div> -->
          <div class="content">
            <div class="acer">
              <div class="item">
                <div>项目名称</div>
                <div>{{ xmInfo.xmmc }}</div>
              </div>
              <div class="item">
                <div>项目编号</div>
                <div>{{ xmInfo.svn_number }}</div>
              </div>
              <div class="item">
                <div>项目阶段</div>
                <div>{{ xmInfo.xmjd }}</div>
              </div>
              <!-- <div class="item">
                <div>质量分类</div>
                <div>{{ xmInfo.qualitysort }}</div>
              </div> -->
              <div class="item">
                <div>项目状态</div>
                <div>{{ xmInfo.xmztmc }}</div>
              </div>
              <div class="item">
                <div>项目总监</div>
                <div>{{ xmInfo.xmzj }}</div>
              </div>
              <div class="item">
                <div>区域总监</div>
                <div>{{ xmInfo.qyzj }}</div>
              </div>
              <div class="item">
                <div>合同</div>
                <div>{{ xmInfo.htqsrq }} - {{ xmInfo.htzzrq }}</div>
              </div>
            </div>
            <!-- <div class="acer">
                <div class="item">
                  <div>项目分类</div>
                  <div>{{ xmInfo.projectsort }}</div>
                </div>
                <div class="item">
                  <div>合同类型</div>
                  <div>{{ xmInfo.htlx }}</div>
                </div>
              </div>
              <div class="acer">
                <div class="item">
                  <div>所属部门</div>
                  <div>{{ xmInfo.bmmc }}</div>
                </div>
                
              </div>
              <div class="acer">
                
              </div> -->
          </div>
        </div>

        <div class="content">
          <div style="padding: 10px 0">
            <div class="card-header" style="border: 0">
              <div class="card-title"><div>质控结果汇总</div></div>
              <div class="card-more">
                <div>
                  <el-radio-group v-model="radio" size="mini">
                    <el-radio-button :label="2">详细页面</el-radio-button>
                    <el-radio-button :label="1">汇总页面</el-radio-button>
                  </el-radio-group>
                </div>
                <div>
                  <el-popover placement="bottom" v-model="visible">
                    <div
                      class="search-wrap"
                      :style="{ width: radio == 2 ? '945px' : '345px' }"
                    >
                      <div v-show="radio == 2">
                        <span>工作事件：</span>
                        <el-select
                          ref="gzsj"
                          v-model="listQuery.gzsj"
                          placeholder="请选择工作事件"
                          filterable
                          size="small"
                          style="width: 120px"
                          class="filter-item"
                          clearable
                        >
                          <el-option
                            v-for="item in gzsjList"
                            :key="item"
                            :label="item"
                            :value="item"
                          ></el-option>
                        </el-select>
                      </div>
                      <div>
                        <span>执行情况：</span>
                        <el-select
                          ref="zxjg"
                          v-model="listQuery.zxjg"
                          filterable
                          size="small"
                          style="width: 120px"
                          class="filter-item"
                          clearable
                        >
                          <el-option
                            v-for="item in zxjgList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </div>
                      <div v-show="radio == 2">
                        <span>检查频率：</span>
                        <el-select
                          ref="jcpl"
                          v-model="listQuery.jcpl"
                          filterable
                          size="small"
                          style="width: 120px"
                          class="filter-item"
                          clearable
                        >
                          <el-option
                            v-for="item in jcplList"
                            :key="item"
                            :label="item"
                            :value="item"
                          ></el-option>
                        </el-select>
                      </div>
                      <div v-show="radio == 2">
                        <span>指标类型：</span>
                        <el-select
                          ref="zblx"
                          v-model="listQuery.zblx"
                          filterable
                          size="small"
                          style="width: 120px"
                          class="filter-item"
                          clearable
                        >
                          <el-option
                            v-for="item in zblxList"
                            :key="item"
                            :label="item"
                            :value="item"
                          ></el-option>
                        </el-select>
                      </div>
                      <div style="text-align: right">
                        <el-button
                          size="mini"
                          type="primary"
                          @click="getZkjgListData()"
                          >查询</el-button
                        >
                        <el-button
                          type="primary"
                          size="mini"
                          @click="handleReset"
                          >重置</el-button
                        >
                      </div>
                    </div>
                    <el-button
                      type="primary"
                      style="margin-right: 10px"
                      size="mini"
                      slot="reference"
                      icon="el-icon-search"
                    ></el-button>
                  </el-popover>
                  <el-button
                    label="left"
                    type="primary"
                    size="mini"
                    v-show="editRole"
                    @click="sendAllMessage"
                  >
                    一键预警
                  </el-button>
                  <el-button
                    label="left"
                    type="primary"
                    size="mini"
                    @click="$router.push('/xmzk/zbImport')"
                    v-show="editRole"
                  >
                    导入
                  </el-button>
                  <el-button
                    label="left"
                    type="primary"
                    size="mini"
                    style="margin-right: 10px"
                    @click="handleExport"
                  >
                    导出
                  </el-button>
                  <el-popover
                    placement="bottom"
                    width="300"
                    trigger="click"
                    v-show="radio == 2"
                  >
                    <div class="card card-zdbj">
                      <div class="card-header">
                        <div class="card-title"><div>展示字段编辑</div></div>
                      </div>
                      <div>
                        <el-checkbox-group
                          v-model="checkList"
                          class="zdbj-check"
                        >
                          <div
                            v-for="item in zdCheckList.zdList"
                            :key="item.zdid"
                          >
                            <el-checkbox :label="item.zdid">
                              {{ item.zdmc }}
                            </el-checkbox>
                          </div>
                        </el-checkbox-group>
                        <div class="zdbj-btn">
                          <el-button
                            label="left"
                            size="mini"
                            @click="checkList = zdCheckList.allCheckVal"
                          >
                            全选
                          </el-button>
                          <el-button
                            label="left"
                            type="primary"
                            size="mini"
                            @click="handleSaveZd"
                          >
                            确定
                          </el-button>
                        </div>
                      </div>
                    </div>
                    <el-button
                      label="left"
                      type="primary"
                      size="mini"
                      slot="reference"
                    >
                      展示字段编辑
                    </el-button>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
          <div></div>
          <el-table
            :data="tableData"
            fit
            highlight-current-row
            :header-cell-style="tableHeaderColor"
            :default-sort="{ prop: 'date', order: 'descending' }"
            tooltip-effect="dark"
            v-show="!loading && radio == 1"
            :max-height="height"
            @scroll="handleScroll"
            border
            ref="table1"
          >
            <el-table-column
              label="指标名称"
              align="center"
              prop="zbmc"
              min-width="200px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="执行情况"
              align="center"
              prop="zxqk"
              min-width="350px"
              :show-overflow-tooltip="true"
              :key="5"
            >
              <template slot="header">
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                  :open-delay="1500"
                >
                  <div slot="content">
                    合格：任务已按要求完成，并达到预定的标准和要求。<br />
                    不合格：任务未能按要求完成，无法达到预定的标准和要求。<br />
                    未开始：任务或工作尚未启动或还未进入实施阶段。<br />
                    未完成：任务或工作已经开始，但尚未完成。<br />
                    豁免：项目特殊情况<br />
                    其余情况均为空<br />
                  </div>
                  <div class="table_header">
                    执行情况&nbsp;
                    <img src="@/img/u285.svg" height="16" alt="" />
                  </div>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span
                  v-for="item in scope.row.zxqk"
                  :key="item.id"
                  style="margin-right: 10px"
                >
                  <!-- '#5fb760' -->
                  <!-- rgb(2, 167, 240) -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="`距离任务到期还有${item.days}天`"
                    placement="top"
                    v-if="item.zxjgmc"
                    :disabled="
                      !(
                        xmInfo.xmztmc == '项目服务中' &&
                        item.days >= 0 &&
                        item.yjbz != '' &&
                        (item.zxjgmc == '未完成' || item.zxjgmc == '空')
                      )
                    "
                  >
                    <el-button
                      @click="handleViewRz(item.rzList, scope.row)"
                      size="mini"
                      :style="{
                        background:
                          item.zxjgmc == '合格'
                            ? '#036eb8'
                            : item.zxjgmc == '不合格'
                            ? '#E13349'
                            : item.zxjgmc == '未完成'
                            ? '#f7b967'
                            : '#bbb',
                        color: '#fff',
                        border: 'none',
                        width: '70px',
                        position: 'relative',
                      }"
                      >{{ item.zxjgmc }}

                      <i
                        class="el-icon-warning-outline"
                        v-if="
                          xmInfo.xmztmc == '项目服务中' &&
                          item.fhtgcs &&
                          item.fhtgcs >= 1
                        "
                        style="position: absolute; top: 0; right: 5px"
                      ></i>
                      <i
                        class="el-icon-s-flag"
                        v-if="
                          xmInfo.xmztmc == '项目服务中' &&
                          item.days >= 0 &&
                          item.yjbz == 'red' &&
                          (item.zxjgmc == '未完成' || item.zxjgmc == '空')
                        "
                        style="
                          position: absolute;
                          bottom: 0;
                          right: 5px;
                          color: #ff0000;
                        "
                      ></i>
                      <i
                        class="el-icon-s-flag"
                        v-if="
                          xmInfo.xmztmc == '项目服务中' &&
                          item.days >= 0 &&
                          item.yjbz == 'yellow' &&
                          (item.zxjgmc == '未完成' || item.zxjgmc == '空')
                        "
                        style="
                          position: absolute;
                          bottom: 0;
                          right: 5px;
                          color: yellow;
                        "
                      ></i>
                    </el-button>
                  </el-tooltip>
                  <div v-else>{{ item.sjjg }}</div>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              min-width="110px"
              align="center"
              fixed="right"
              class-name="small-padding fixed-width"
              v-if="applyRole || editRole"
            >
              <template slot-scope="scope">
                <el-dropdown trigger="click">
                  <el-button type="primary" size="small">
                    操作列
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="applyRole">
                      <div @click="handleApplyCheck(scope.row)">
                        <el-button type="text" size="small">申请复核</el-button>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        editRole && scope.row.zxqk && scope.row.zxqk.length > 0
                      "
                    >
                      <div @click="handleEditResult(scope.row, scope.$index)">
                        <el-button type="text" size="small">编辑结果</el-button>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        editRole &&
                        scope.row.zxqk &&
                        scope.row.zxqk.length > 0 &&
                        scope.row.isYj == 1
                      "
                    >
                      <div @click="sendMessage(scope.row)">
                        <el-button type="text" size="small">预警推送</el-button>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="nodata">
                <img src="@/img/nodata.png" alt="" width="160" />
                <div>暂无数据</div>
              </div>
            </template>
          </el-table>
          <el-table
            :data="tableData"
            fit
            highlight-current-row
            :header-cell-style="tableHeaderColor"
            :default-sort="{ prop: 'date', order: 'descending' }"
            tooltip-effect="dark"
            v-show="!loading && radio == 2"
            :max-height="height"
            border
            ref="table2"
          >
            <el-table-column
              label="工作事件"
              align="center"
              prop="gzsj"
              min-width="80px"
              fixed="left"
              :show-overflow-tooltip="true"
              v-if="showTableZd.gzsj"
              :key="1"
            />
            <el-table-column
              label="指标名称"
              align="center"
              prop="zbmc"
              min-width="150px"
              :show-overflow-tooltip="true"
              v-if="showTableZd.zbmc"
              :key="2"
            />
            <el-table-column
              label="质量标准"
              align="center"
              prop="zlbz"
              min-width="100px"
              :show-overflow-tooltip="true"
              v-if="showTableZd.zlbz"
              :key="3"
            />
            <el-table-column
              label="检查频率"
              align="center"
              prop="jcpl"
              min-width="100px"
              :show-overflow-tooltip="true"
              v-if="showTableZd.jcpl"
              :key="4"
            />
            <el-table-column
              label="执行情况"
              align="center"
              prop="zxqk"
              min-width="350px"
              :show-overflow-tooltip="true"
              :key="5"
            >
              <template slot="header">
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                  :open-delay="1500"
                >
                  <div slot="content">
                    合格：任务已按要求完成，并达到预定的标准和要求。<br />
                    不合格：任务未能按要求完成，无法达到预定的标准和要求。<br />
                    未开始：任务或工作尚未启动或还未进入实施阶段。<br />
                    未完成：任务或工作已经开始，但尚未完成。<br />
                    豁免：项目特殊情况<br />
                    其余情况均为空<br />
                  </div>
                  <div class="table_header">
                    执行情况&nbsp;
                    <img src="@/img/u285.svg" height="16" alt="" />
                  </div>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span
                  v-for="item in scope.row.zxqk"
                  :key="item.id"
                  style="margin-right: 10px"
                >
                  <!-- '#5fb760' -->
                  <!-- rgb(2, 167, 240) -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="`距离任务到期还有${item.days}天`"
                    placement="top"
                    v-if="item.zxjgmc"
                    :disabled="
                      !(
                        xmInfo.xmztmc == '项目服务中' &&
                        item.days >= 0 &&
                        item.yjbz != '' &&
                        (item.zxjgmc == '未完成' || item.zxjgmc == '空')
                      )
                    "
                  >
                    <el-button
                      @click="handleViewRz(item.rzList, scope.row)"
                      size="mini"
                      :style="{
                        background:
                          item.zxjgmc == '合格'
                            ? '#036eb8'
                            : item.zxjgmc == '不合格'
                            ? '#E13349'
                            : item.zxjgmc == '未完成'
                            ? '#f7b967'
                            : '#bbb',
                        color: '#fff',
                        border: 'none',
                        width: '70px',
                        position: 'relative',
                      }"
                      >{{ item.zxjgmc }}

                      <i
                        class="el-icon-warning-outline"
                        v-if="
                          xmInfo.xmztmc == '项目服务中' &&
                          item.fhtgcs &&
                          item.fhtgcs >= 1
                        "
                        style="position: absolute; top: 0; right: 5px"
                      ></i>
                      <i
                        class="el-icon-s-flag"
                        v-if="
                          xmInfo.xmztmc == '项目服务中' &&
                          item.days >= 0 &&
                          item.yjbz == 'red' &&
                          (item.zxjgmc == '未完成' || item.zxjgmc == '空')
                        "
                        style="
                          position: absolute;
                          bottom: 0;
                          right: 5px;
                          color: #ff0000;
                        "
                      ></i>
                      <i
                        class="el-icon-s-flag"
                        v-if="
                          xmInfo.xmztmc == '项目服务中' &&
                          item.days >= 0 &&
                          item.yjbz == 'yellow' &&
                          (item.zxjgmc == '未完成' || item.zxjgmc == '空')
                        "
                        style="
                          position: absolute;
                          bottom: 0;
                          right: 5px;
                          color: yellow;
                        "
                      ></i>
                    </el-button>
                  </el-tooltip>
                  <div v-else>{{ item.sjjg }}</div>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="关联模型节点"
              align="center"
              prop="zjmx"
              min-width="120px"
              :show-overflow-tooltip="true"
              v-if="showTableZd.zjmx"
              :key="6"
            >
            </el-table-column>
            <el-table-column
              label="项目计划"
              align="center"
              prop="xmjh"
              min-width="220px"
              :show-overflow-tooltip="true"
              v-if="showTableZd.xmjh"
              :key="7"
            >
              <template slot="header">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="系统将自动匹配项管系统中对应的项目计划，并进行回显，对应指标必须存在对应的关键动作/规划内容，才会成功匹配，否则显示为无，不存在对应计划"
                  placement="top"
                  :open-delay="1500"
                >
                  <div class="table_header">
                    项目计划&nbsp;
                    <img src="@/img/u285.svg" height="16" alt="" />
                  </div>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  v-if="scope.row.xmjh"
                  @click="getPlanListData(scope.row)"
                >
                  查看计划
                </el-button>
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  v-if="scope.row.sgzbsql"
                  @click="getSqlData(scope.row)"
                >
                  查看数据
                </el-button>
                <!-- <div v-if="!scope.row.sgzbsql && !scope.row.xmjh">无</div> -->
              </template>
            </el-table-column>

            <el-table-column
              label="指标类型"
              align="center"
              min-width="80px"
              prop="zblx"
              :show-overflow-tooltip="true"
              v-if="showTableZd.zblx"
              :key="8"
            />
            <el-table-column
              label="成果物"
              align="center"
              prop="cgw"
              min-width="80px"
              :show-overflow-tooltip="true"
              v-if="showTableZd.cgw"
              :key="9"
            >
              <template slot-scope="scope">
                <div
                  @click="getCgwListData(scope.row)"
                  v-if="scope.row.cgw + scope.row.wjs != 0"
                >
                  <span
                    style="font-weight: 700; color: #036eb8; cursor: pointer"
                    >{{ scope.row.cgw + scope.row.wjs }}</span
                  >
                </div>
                <!-- <div v-else>无</div> -->
              </template>
            </el-table-column>
            <el-table-column
              label="检查标准"
              align="center"
              prop="jcbz"
              min-width="200px"
              v-if="showTableZd.jcbz"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="操作"
              width="100px"
              align="center"
              fixed="right"
              class-name="small-padding fixed-width"
              :key="10"
              v-if="applyRole || editRole"
            >
              <template slot-scope="scope">
                <el-dropdown trigger="click">
                  <el-button type="primary" size="small">
                    操作列
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="applyRole">
                      <div @click="handleApplyCheck(scope.row)">
                        <el-button type="text" size="small">申请复核</el-button>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        editRole && scope.row.zxqk && scope.row.zxqk.length > 0
                      "
                    >
                      <div @click="handleEditResult(scope.row, scope.$index)">
                        <el-button type="text" size="small">编辑结果</el-button>
                      </div>
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="
                        editRole &&
                        scope.row.zxqk &&
                        scope.row.zxqk.length > 0 &&
                        scope.row.isYj == 1
                      "
                    >
                      <div @click="sendMessage(scope.row)">
                        <el-button type="text" size="small">预警推送</el-button>
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="nodata">
                <img src="@/img/nodata.png" alt="" width="160" />
                <div>暂无数据</div>
              </div>
            </template>
          </el-table>
        </div>
      </div>
    </div>
    <!-- <div v-if="rzList && rzList.length > 0">
      <div class="card">
        <div class="card-header">
          <div class="card-title"><div>日志记录（先选中指标结果）</div></div>
        </div>
        <div class="content">
          <el-table
            :max-height="400"
            :data="rzList"
            fit
            highlight-current-row
            :default-sort="{ prop: 'date', order: 'descending' }"
            tooltip-effect="dark"
          >
     
            <el-table-column
              label="指标名称"
              align="center"
              prop="zbmc"
              min-width="120px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="时间"
              align="center"
              prop="sj"
              min-width="80px"
              :show-overflow-tooltip="true"
            />

            <el-table-column
              label="更新类型"
              align="center"
              prop="gxlx"
              min-width="80px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="变更后"
              align="center"
              prop="czhjg"
              min-width="80px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="变更前"
              align="center"
              prop="czqjg"
              min-width="80px"
              :show-overflow-tooltip="true"
            />
            <el-table-column
              label="更新说明"
              align="center"
              prop="gxsm"
              min-width="130px"
              :show-overflow-tooltip="true"
            />
          </el-table>
        </div>
      </div>
    </div> -->
    <el-dialog
      title="编辑结果"
      :visible.sync="editResultDialog"
      width="600px"
      :closeOnClickModal="false"
      v-if="editResultDialog"
      class="editResultDialog"
    >
      <div>
        <el-form
          ref="editResultFrom"
          :model="editResultFrom"
          :rules="editResultRules"
          label-width="120px"
          class="userManage-from"
        >
          <el-form-item label="质控指标：" prop="zkjgid">
            <el-select
              ref="zkjgid"
              v-model="editResultFrom.id"
              placeholder=""
              style="width: 100%"
              size="small"
              class="filter-item"
              @change="handleChangeZkjg"
            >
              <el-option
                v-for="item in zkzbOption"
                :key="item.id"
                :label="`${checkRow.zbmc}(${item.sjplmc})`"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="所属季度：" prop="ssjd">
            <el-select
              v-model="editResultFrom.ssjd"
              placeholder=""
              clearable
              style="width: 100%"
              size="small"
              :disabled="editResultFrom.len == 4"
              class="filter-item"
            >
              <el-option label="一季度" :value="1" />
              <el-option label="二季度" :value="2" />
              <el-option label="三季度" :value="3" />
              <el-option label="四季度" :value="4" />
            </el-select>
          </el-form-item>

          <el-form-item label="当前结果：" prop="fromTitle">
            <el-select
              v-model="editResultFrom.czqjg"
              placeholder=""
              clearable
              style="width: 100%"
              size="small"
              class="filter-item"
              disabled
            >
              <el-option label="未开始" value="1" />
              <el-option label="未完成" value="2" />
              <el-option label="合格" value="3" />
              <el-option label="不合格" value="4" />
              <el-option label="豁免" value="5" />
              <el-option label="空" value="6" />
            </el-select>
          </el-form-item>
          <el-form-item label="修改结果：" prop="czhjg">
            <el-select
              v-model="editResultFrom.czhjg"
              placeholder=""
              clearable
              style="width: 100%"
              size="small"
              class="filter-item"
            >
              <el-option label="未开始" value="1" />
              <el-option label="未完成" value="2" />
              <el-option label="合格" value="3" />
              <el-option label="不合格" value="4" />
              <el-option label="豁免" value="5" />
            </el-select>
          </el-form-item>
          <el-form-item label="编辑说明：" prop="gxsm">
            <el-input
              placeholder="请输入编辑说明"
              v-model="editResultFrom.gxsm"
              type="textarea"
              :autosize="{ minRows: 5, maxRows: 5 }"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="操作人：" prop="xm">
            <el-input v-model="user.xm" disabled show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editResultDialog = false">取消</el-button>
        <el-button type="primary" @click="submitEditForm">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="申请复核"
      :visible.sync="applyCheckDialog"
      width="600px"
      :closeOnClickModal="false"
      v-if="applyCheckDialog"
      class="applyCheckDialog"
    >
      <div>
        <el-form
          ref="applyCheckFrom"
          :model="applyCheckFrom"
          :rules="applyCheckRules"
          label-width="120px"
          class="userManage-from"
        >
          <div class="card apply-check-card" style="padding-bottom: 0">
            <div class="card-header">
              <div class="card-title"><div>指标信息</div></div>
            </div>
            <div class="content" style="padding-top: 20px">
              <el-form-item label="质控指标：" prop="zkjgid">
                <el-select
                  ref="zkjgid"
                  v-model="applyCheckFrom.id"
                  placeholder=""
                  style="width: 100%"
                  size="small"
                  class="filter-item"
                  @change="handleChangeZkjg"
                >
                  <el-option
                    v-for="item in zkzbOption"
                    :key="item.id"
                    :label="`${checkRow.zbmc}(${item.sjplmc})`"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>

              <el-form-item label="当前结果：" prop="fromTitle">
                <el-select
                  v-model="applyCheckFrom.czqjg"
                  placeholder=""
                  clearable
                  style="width: 100%"
                  size="small"
                  class="filter-item"
                  disabled
                >
                  <el-option label="未开始" value="1" />
                  <el-option label="未完成" value="2" />
                  <el-option label="合格" value="3" />
                  <el-option label="不合格" value="4" />
                  <el-option label="豁免" value="5" />
                  <el-option label="空" value="6" />
                </el-select>
              </el-form-item>
              <!-- <el-form-item label=" 扣罚标准：" prop="fromTitle">
                <el-input v-model="checkRow.kfbz" disabled></el-input>
              </el-form-item>
              <el-form-item label=" 关联项目计划：" prop="fromTitle">
                <el-input v-model="checkRow.xmjh" disabled></el-input>
              </el-form-item> -->
            </div>
          </div>
          <div class="card apply-check-card" style="padding-bottom: 0">
            <div class="card-header">
              <div class="card-title"><div>申请变更</div></div>
            </div>
            <div class="content" style="padding-top: 20px">
              <el-form-item label="申请结果：" prop="sqjg">
                <el-select
                  v-model="applyCheckFrom.sqjg"
                  placeholder=""
                  clearable
                  style="width: 100%"
                  size="small"
                  class="filter-item"
                >
                  <el-option label="未开始" value="1" />
                  <el-option label="未完成" value="2" />
                  <el-option label="合格" value="3" />
                  <el-option label="不合格" value="4" />
                  <el-option label="豁免" value="5" />
                </el-select>
              </el-form-item>

              <el-form-item label="申请说明：" prop="sqsm">
                <el-input
                  placeholder="申请说明"
                  v-model="applyCheckFrom.sqsm"
                  type="textarea"
                  :autosize="{ minRows: 5, maxRows: 5 }"
                  maxlength="100"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item label=" 相关材料：" prop="file">
                <el-upload
                  class="upload-demo"
                  action="#"
                  ref="upload"
                  :headers="headers"
                  :on-change="handleChangeFiles"
                  :on-exceed="handleExceed"
                  :auto-upload="false"
                  multiple
                  :limit="5"
                  :file-list="fileList"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    支持上传图片（png、jpg、bmp）、Excel文档、Word文档、Pdf文档
                  </div>
                </el-upload>
              </el-form-item>
              <!-- <el-form-item label="审批人：" prop="sprXm">
                <el-input v-model="sprXm" disabled></el-input>
              </el-form-item> -->
            </div>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="applyCheckDialog = false">取消</el-button>
        <el-button type="primary" @click="handleSaveApply">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="成果物列表"
      :visible.sync="cgwListDialog"
      width="1200px"
      :closeOnClickModal="false"
      v-if="cgwListDialog"
      :show-close="false"
    >
      <div>
        <el-table
          :max-height="400"
          :data="cgwList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          border
          :header-cell-style="tableHeaderColor"
          tooltip-effect="dark"
        >
          <el-table-column
            label="成果物名称"
            align="center"
            prop="wjmc"
            min-width="150px"
          >
            <template slot-scope="scope">
              <div
                style="color: #036eb8; cursor: pointer"
                @click="handleViewCgw(scope.row)"
              >
                {{ scope.row.wjmc }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="成果物类型"
            align="center"
            prop="lx"
            min-width="60px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="所属季度"
            align="center"
            prop="jd"
            min-width="60px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="SVN地址"
            align="center"
            prop="svnurl"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="提交人"
            align="center"
            prop="xm"
            min-width="60px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="提交时间"
            align="center"
            prop="uploadtime"
            min-width="100px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="操作列"
            align="center"
            prop="gxlx"
            min-width="50px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                @click="downloadSvnFile(scope.row)"
                size="mini"
                type="text"
                >下载</el-button
              >
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cgwListDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="计划列表"
      :visible.sync="planListDialog"
      width="600px"
      :closeOnClickModal="false"
      v-if="planListDialog"
      :show-close="false"
    >
      <div>
        <el-table
          :data="planList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          border
          :header-cell-style="tableHeaderColor"
          :max-height="400"
        >
          <el-table-column
            label="项目计划名称"
            align="center"
            prop="plan_name"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                style="cursor: pointer; color: #036eb8"
                @click="handleToPlan(scope.row)"
              >
                {{ scope.row.plan_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="匹配关键动作/规划"
            align="center"
            prop="zjmx"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="planListDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="查看详情"
      :visible.sync="logDialog"
      width="800px"
      :closeOnClickModal="false"
      v-if="logDialog"
      :show-close="false"
    >
      <div>
        <div class="logDes">
          <div><span>指标名称：</span>{{ viewItem.zbmc }}</div>
          <div><span>质量标准：</span><span v-html="viewItem.zlbz"></span></div>
          <div><span>检查标准：</span><span v-html="viewItem.jcbz"></span></div>
          <div v-if="viewItem.jmgz">
            <span>减免规则：</span><span v-html="viewItem.jmgz"></span>
          </div>
        </div>
        <el-table
          :max-height="400"
          :data="rzList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          border
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column
            label="时间"
            align="center"
            prop="sj"
            min-width="140px"
            :show-overflow-tooltip="true"
          />

          <el-table-column
            label="更新类型"
            align="center"
            prop="gxlx"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="变更前"
            align="center"
            prop="czqjg"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="变更后"
            align="center"
            prop="czhjg"
            min-width="80px"
            :show-overflow-tooltip="true"
          />

          <el-table-column
            label="更新说明"
            align="center"
            prop="gxsm"
            min-width="130px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="操作人"
            align="center"
            prop="czr"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="logDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="`${sql_zbid != 47 ? '数据列表' : '指标执行情况'}`"
      :visible.sync="sqlDialog"
      width="60%"
      :closeOnClickModal="false"
      v-if="sqlDialog"
      :show-close="false"
    >
      <div>
        <el-table
          :data="sqlList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          v-show="
            sql_zbid != 8 &&
            sql_zbid != 9 &&
            sql_zbid != 47 &&
            sql_zbid != 49 &&
            sql_zbid != 35 &&
            sql_zbid != 36 &&
            sql_zbid != 52 &&
            sql_zbid != 53 &&
            sql_zbid != 26 &&
            sql_zbid != 28 &&
            sql_zbid != 25 &&
            sql_zbid != 51
          "
          border
          :header-cell-style="tableHeaderColor"
          :max-height="400"
        >
          <el-table-column
            label="参与人"
            align="center"
            prop="key"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="岗位名称"
            align="center"
            prop="gwmc"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>

          <el-table-column
            label="工作量（天）"
            align="center"
            prop="value"
            min-width="120px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <div
                :style="{
                  cursor:
                    sql_zbid == 46 || sql_zbid == 39 ? 'pointer' : 'default',
                  color: sql_zbid == 46 || sql_zbid == 39 ? '#036eb8' : '#000',
                }"
                @click="handleClickGzl(scope.row)"
              >
                {{ scope.row.value }}
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <el-table
          :data="sqlList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          v-show="sql_zbid == 8"
          border
          :header-cell-style="tableHeaderColor"
          :max-height="400"
        >
          <el-table-column
            label="申请时间"
            align="center"
            prop="key"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="到岗时间"
            align="center"
            prop="value"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <el-table
          :data="sqlList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          v-show="
            sql_zbid == 26 || sql_zbid == 28 || sql_zbid == 35 || sql_zbid == 36
          "
          border
          :header-cell-style="tableHeaderColor"
          :max-height="400"
        >
          <el-table-column
            label="审核人"
            align="center"
            prop="xm"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="审核时间"
            align="center"
            prop="sj"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            v-if="sql_zbid == 26 || sql_zbid == 28 || sql_zbid == 35"
            label="评审结果"
            align="center"
            prop="zt"
            min-width="200px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            v-if="sql_zbid == 28 || sql_zbid == 36"
            label="评审意见"
            align="center"
            prop="bz"
            min-width="200px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <el-table
          :data="sqlList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          v-show="sql_zbid == 47"
          border
          :header-cell-style="tableHeaderColor"
          :max-height="400"
        >
          <el-table-column
            label="最佳模型节点"
            align="center"
            prop="key"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="执行次数"
            align="center"
            prop="value"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>

        <el-table
          :data="sqlList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          v-show="sql_zbid == 9"
          border
          :header-cell-style="tableHeaderColor"
          :max-height="400"
        >
          <el-table-column
            label="变更申请时间"
            align="center"
            prop="key"
            min-width="100px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="一把手到岗时间"
            align="center"
            prop="value"
            min-width="100px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>

        <el-table
          :data="sqlList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          v-show="sql_zbid == 51"
          border
          :header-cell-style="tableHeaderColor"
          :max-height="400"
        >
          <el-table-column
            label="提交人"
            align="center"
            prop="key"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="提交时间"
            align="center"
            prop="value"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>

        <el-table
          :data="sqlList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          v-show="sql_zbid == 25"
          border
          :header-cell-style="tableHeaderColor"
          :max-height="400"
        >
          <el-table-column
            label="统计周期"
            align="center"
            prop="key"
            min-width="200px"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
            label="存款数据量"
            align="center"
            prop="value"
            min-width="150px"
            :show-overflow-tooltip="true"
            key="3"
          >
          </el-table-column>
          <el-table-column
            label="基准值"
            align="center"
            prop="jzz"
            min-width="150px"
            :show-overflow-tooltip="true"
            key="3"
          >
          </el-table-column>
          <el-table-column
            label="标准"
            align="center"
            prop="bz"
            min-width="150px"
            :show-overflow-tooltip="true"
            key="3"
          >
          </el-table-column>
          <el-table-column
            label="总调度跑数时间"
            align="center"
            prop="zdd"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>

        <el-table
          :data="sqlList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          v-show="sql_zbid == 49"
          border
          :header-cell-style="tableHeaderColor"
          :max-height="400"
        >
          <el-table-column
            label="季度"
            align="center"
            prop="ssjd"
            min-width="100px"
            :show-overflow-tooltip="true"
            key="1"
          >
          </el-table-column>
          <el-table-column
            label="拜访时间"
            align="center"
            prop="key"
            min-width="100px"
            :show-overflow-tooltip="true"
            key="2"
          >
          </el-table-column>
          <el-table-column
            label="拜访时长"
            align="center"
            prop="gtsc"
            min-width="100px"
            :show-overflow-tooltip="true"
            key="2"
          >
          </el-table-column>
          <el-table-column
            label="拜访人员"
            align="center"
            prop="bfry"
            min-width="150px"
            :show-overflow-tooltip="true"
            key="3"
          >
            <template slot-scope="scope">
              <div v-html="scope.row.bfry.split(',').join('<br/>')"></div>
            </template>
          </el-table-column>
          <el-table-column
            label="拜访对象"
            align="center"
            prop="value"
            min-width="150px"
            :show-overflow-tooltip="true"
            key="4"
          >
            <template slot-scope="scope">
              <div v-html="scope.row.value.split(',').join('<br/>')"></div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <el-table
          :data="sqlList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          v-show="sql_zbid == 52"
          border
          :header-cell-style="tableHeaderColor"
          :max-height="400"
        >
          <el-table-column
            label="月份"
            align="center"
            prop="yf"
            min-width="100px"
            :show-overflow-tooltip="true"
            key="1"
          >
          </el-table-column>
          <el-table-column
            label="当期考核人数"
            align="center"
            prop="key"
            min-width="100px"
            :show-overflow-tooltip="true"
            key="2"
          >
          </el-table-column>

          <el-table-column
            label="人均每月登录操作次数"
            align="center"
            prop="value"
            min-width="150px"
            :show-overflow-tooltip="true"
            key="4"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <el-table
          :data="sqlList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          v-show="sql_zbid == 53"
          border
          :header-cell-style="tableHeaderColor"
          :max-height="400"
        >
          <el-table-column
            label="统计月份"
            align="center"
            prop="yf"
            min-width="100px"
            :show-overflow-tooltip="true"
            key="1"
          >
          </el-table-column>
          <el-table-column
            label="当期考核人数"
            align="center"
            prop="key"
            min-width="100px"
            :show-overflow-tooltip="true"
            key="2"
          >
          </el-table-column>

          <el-table-column
            label="活跃用户数"
            align="center"
            prop="value"
            min-width="100px"
            :show-overflow-tooltip="true"
            key="4"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sqlDialog = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="工作明细"
      :visible.sync="workDetailDialog"
      :closeOnClickModal="false"
      v-if="workDetailDialog"
      append-to-body
      :show-close="false"
    >
      <div>
        <el-table
          :max-height="400"
          :data="workDetailList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          border
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column
            label="姓名"
            align="center"
            prop="xm"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="日期"
            align="center"
            prop="qdsj"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="工作量"
            align="center"
            prop="gzsj"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="工作内容"
            align="center"
            prop="jlnr"
            min-width="150px"
            :show-overflow-tooltip="true"
          />

          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="workDetailDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  exportZkjgList,
  getCgwList,
  getJdspr,
  getPlanList,
  getRypzZbgzlDataList,
  getTsZbDataList,
  getXmList,
  getZkjgList,
  getZszdList,
  insertZkfh,
  saveZszd,
  sendYjMessage,
  updateZkjg,
  uploadFile,
} from "@/api/xmzk";
import { deepClone } from "@/utils/utils";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["user"]),
  },
  watch: {
    filterText(val) {
      if (!val) {
        this.changeTreeNodeStatus(this.$refs.tree.store.root);
      }
      this.$refs.tree.filter(val);
    },
    // setCheckedNodes(val) {
    //   this.$refs.tree.filter(val);
    // },
  },
  data() {
    return {
      height: 0,
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      loading: false,
      radio: 2,
      checkList: [],
      zdCheckList: {},
      xmInfo: {},
      zkzbOption: [], // 编辑弹窗质控指标字段。需要过滤掉未开始
      showTableZd: {},
      xmSeleltParams: {
        xmmc: null,
        year: moment(),
      },
      defaultProps: {
        children: "xmList",
        label: "xmmc",
        value: "xmbh",
      },
      xmList: [],
      filterText: "",
      xmbh: null,
      tableData: [],
      rzList: [],
      margeArray: [],
      editResultDialog: false,
      editDialog: true,
      applyCheckDialog: false,
      cgwListDialog: false,
      planListDialog: false,
      workDetailDialog: false,
      editResultFrom: {},
      editIndex: 0,
      applyCheckFrom: {},
      visible: false,
      editResultRules: {
        gxsm: [
          { required: true, message: "编辑说明不能为空", trigger: "change" },
        ],
        zkjgid: [
          { required: true, message: "质控指标不能为空", trigger: "change" },
        ],
        czhjg: [
          { required: true, message: "修改结果不能为空", trigger: "change" },
        ],
      },
      applyCheckRules: {
        sqsm: [
          { required: true, message: "申请说明不能为空", trigger: "change" },
        ],
        zkjgid: [
          { required: true, message: "质控指标不能为空", trigger: "change" },
        ],
        sqjg: [
          { required: true, message: "申请结果不能为空", trigger: "change" },
        ],
      },
      checkRow: {},
      cgwList: [],
      fileList: [],
      sprXm: null,
      sprId: null,
      editRole: false,
      applyRole: false,
      planList: [],
      logDialog: false,
      sqlList: [],
      sqlDialog: false,
      sql_zbid: null,
      scrollTopTable1: 0,
      scrollTopTable2: 0,
      expandedList: [],
      zxjgList: [
        { label: "未开始", value: "1" },
        { label: "未完成", value: "2" },
        { label: "合格", value: "3" },
        { label: "不合格", value: "4" },
        { label: "豁免", value: "5" },
        { label: "空", value: "6" },
      ],
      listQuery: {
        gzsj: "",
        zxjg: "",
        jcpl: "",
        zblx: "",
      },
      gzsjList: [],
      jcplList: [],
      zblxList: [],
      viewItem: {},
      workDetailList: [],
      saveLoading: false,
    };
  },
  created() {
    if (!this.user.xm) {
      this.$store.dispatch("common/fetchUserInfoAction").then((res) => {
        if (this.user.roleName.indexOf("质量管理组") > -1) {
          this.editRole = true;
        }
      });
    } else {
      if (this.user.roleName.indexOf("质量管理组") > -1) {
        this.editRole = true;
      }
    }
    this.getTableZd();
    this.getXmListData(true);
    // getPlanList().then(res=>{
    // })
  },
  mounted() {
    this.$refs.table1.bodyWrapper.addEventListener(
      "scroll",
      (res) => {
        const height = res.target;
        const scrollTop = height.scrollTop;
        this.scrollTopTable1 = scrollTop;
      },
      true
    );
    this.$refs.table2.bodyWrapper.addEventListener(
      "scroll",
      (res) => {
        const height = res.target;
        const scrollTop = height.scrollTop;
        this.scrollTopTable2 = scrollTop;
      },
      true
    );
  },
  methods: {
    getTableZd() {
      getZszdList().then((res) => {
        if (res.code == 0) {
          this.zdCheckList = res.data;
          let temp = [];
          let temp2 = [];
          this.showTableZd = {};
          for (let i of this.zdCheckList.ygzd) {
            temp.push(i.zdid);
            this.showTableZd[i.zdid] = true;
          }
          for (let i of this.zdCheckList.zdList) {
            temp2.push(i.zdid);
          }
          this.checkList = temp;
          this.zdCheckList.allCheckVal = temp2;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    submitEditForm() {
      // if (!this.editDialog) {
      //   console.log(this.editDialog);
      //   return;
      // }
      if (this.saveLoading) {
        return;
      }
      const { zkjgid, czqjg, czhjg, gxsm, ssjd } = this.editResultFrom;

      this.$refs["editResultFrom"].validate((valid) => {
        if (valid) {
          this.saveLoading = true;

          updateZkjg({ zkjgid, czqjg, czhjg, gxsm, ssjd }).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.editResultDialog = false;
              this.$refs.table1.scrollTop = this.scrollTopTable1;
              this.$refs.table2.scrollTop = this.scrollTopTable2;
              for (let i in this.tableData[this.editIndex].zxqk) {
                if (this.tableData[this.editIndex].zxqk[i].id == zkjgid) {
                  this.tableData[this.editIndex].zxqk[i].zxjg = czhjg;
                  this.tableData[this.editIndex].zxqk[i].zxjgmc =
                    this.zxjgList.filter((e) => {
                      return e.value == czhjg;
                    })[0].label;
                  this.tableData[this.editIndex].zxqk[i].ssjd = ssjd;
                }
              }
              this.editDialog = false;

              // this.getZkjgListData();
            } else {
              this.$message.error(res.msg);
              this.editDialog = true;
            }
            this.saveLoading = false;
          });
        }
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.xmmc.indexOf(value) !== -1;
    },
    handleChangeYear() {
      this.filterText = "";
      this.getXmListData();
    },
    getXmListData(firstLoad) {
      const xmParams = {
        ...this.xmSeleltParams,
        year: moment(this.xmSeleltParams.year).format("YYYY"),
      };
      getXmList(xmParams).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
          for (let i in this.xmList) {
            this.xmList[i].xmmc = this.xmList[i].bmmc2;
            this.xmList[i].xmbh = i;
          }
          if (localStorage.getItem("zk_xmbh")) {
            this.xmbh = localStorage.getItem("zk_xmbh");
            localStorage.removeItem("zk_xmbh");
            this.getZkjgListData();
            return;
          }
          if (firstLoad) {
            this.xmbh = this.xmList[0].xmList[0].xmbh;
            this.expandedList = [];
            //

            // setTimeout(() => {
            // this.$refs.tree.treeItemArray[0].classList.add("is-expanded");
            // this.$refs.tree.treeItemArray[0].classList.add("is-focusable");
            // this.$refs.tree.treeItemArray[0].classList.add("is-current");
            // this.$refs.tree.treeItemArray[0].children[1].style.display =
            //   "block";
            // }, 500);
            this.getZkjgListData();
            return;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getZkjgListData() {
      this.loading = true;
      getZkjgList({
        xmbh: this.xmbh,
        year: moment(this.xmSeleltParams.year).format("YYYY"),
        ...this.listQuery,
      }).then((res) => {
        this.loading = false;
        if (res.code == 0) {
          this.tableData = res.data.list;
          for (let i in this.tableData) {
            this.tableData[i].isYj = 1;
            this.gzsjList.push(this.tableData[i].gzsj);
            this.jcplList.push(this.tableData[i].jcpl);
            this.zblxList.push(this.tableData[i].zblx);
            for (let item of this.tableData[i].zxqk) {
              if (item.isdq == 1 && (item.zxjg == 3 || item.zxjg == 5)) {
                this.tableData[i].isYj = 0;
              }
            }
          }
          this.gzsjList = [...new Set(this.gzsjList)];
          this.jcplList = [...new Set(this.jcplList)];
          this.zblxList = [...new Set(this.zblxList)];
          this.xmInfo = res.data.info;
          const docH = document.documentElement.clientHeight;
          const mycontainerH = document.querySelector(".xmzk").clientHeight;
          this.height = docH - 150;
          document.querySelector(".project-select").style.maxHeight =
            docH - 52 + "px";
          const timer = setInterval(() => {
            if (this.user?.xm) {
              this.applyRole =
                this.xmInfo.isxmcy == 1 ||
                this.xmInfo.xmzj == this.user.xm ||
                this.xmInfo.qyzj == this.user.xm;
              clearInterval(timer);
            }
          }, 50);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleNodeClick(e) {
      if (!e.bmmc) {
        this.xmbh = e.xmbh;

        this.getZkjgListData();
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    handleSaveZd() {
      const zdid = this.checkList.join(",");
      if (this.saveLoading) {
        return;
      }
      this.saveLoading = true;

      saveZszd({ zdid }).then((res) => {
        if (res.code == 0) {
          this.saveLoading = false;
          this.getTableZd();
          this.getZkjgListData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleEditResult(row, index) {
      this.editResultDialog = true;
      this.checkRow = deepClone(row);
      let temp = [];
      let id = null;
      let zxjg = null;
      let zkjgid = null;
      let ssjd = null;
      if (row.zblx == "手工指标") {
        for (let i of row.zxqk) {
          temp.push(i);
          //是否当季、当上半年 ，是勾选次季度指标
          if (i.isdq == 1) {
            id = i.id;
            zxjg = i.zxjg;
            zkjgid = i.id;
            ssjd = i.ssjd;
          }
        }
      } else {
        for (let i of row.zxqk) {
          // if (
          //   (i.zxjg == 2 ||
          //     i.zxjg == 3 ||
          //     i.zxjg == 4 ||
          //     i.zxjg == 5 ||
          //     i.zxjg == 6) &&
          //   !(i.zbid == 26 || i.zbid == 28 || i.zbid == 45)
          // ) {
          //   temp.push(i);
          // }
          // if (i.zbid == 26 || i.zbid == 28 || i.zbid == 45) {
          //   temp.push(i);
          // }
          temp.push(i);
          //是否当季、当上半年 ，是勾选次季度指标
          if (i.isdq == 1) {
            id = i.id;
            zxjg = i.zxjg;
            zkjgid = i.id;
            ssjd = i.ssjd;
          }
        }
      }
      if (id == null) {
        //取最后一条结果
        let i = row.zxqk[row.zxqk.length - 1];
        id = i.id;
        zxjg = i.zxjg;
        zkjgid = i.id;
        ssjd = i.ssjd;
      }
      this.zkzbOption = temp;
      this.editIndex = index;
      this.editResultFrom = {
        id,
        zkjgid,
        czqjg: zxjg,
        ssjd,
        len: row.zxqk.length,
      };
    },
    sendMessage(row, index) {
      const { xmzt } = this.xmInfo;
      const { status } = row;
      const xmbh = this.xmbh;
      let id = null;
      for (let i of row.zxqk) {
        if (i.isdq == 1) {
          id = i.id;
        }
      }
      if (xmzt != 1 || status != 1) {
        this.$confirm("是否确认推送！", row.zbmc, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(function () {
            return sendYjMessage({
              xmbh: xmbh,
              id: id,
            });
          })
          .then((res) => {
            if (res.code == 0) {
              this.$notify({
                title: "成功",
                message: "推送成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$notify({
                title: "推送成功",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
          });
      } else {
        sendYjMessage({
          xmbh: xmbh,
          id: id,
        }).then((res) => {
          if (res.code == 0) {
            this.$notify({
              title: "成功",
              message: "推送成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$notify({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
        });
      }
    },
    sendAllMessage() {
      const { xmmc, xmzt } = this.xmInfo;
      const xmbh = this.xmbh;
      if (xmzt != 1) {
        this.$confirm("项目状态不在服务中，是否确认一键推送！", xmmc, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(function () {
            return sendYjMessage({
              xmbh: xmbh,
              id: "",
            });
          })
          .then((res) => {
            if (res.code == 0) {
              this.$notify({
                title: "成功",
                message: "推送成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$notify({
                title: "失败",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
          });
      } else {
        sendYjMessage({
          xmbh: xmbh,
          id: "",
        }).then((res) => {
          if (res.code == 0) {
            this.$notify({
              title: "成功",
              message: "推送成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$notify({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
        });
      }
    },
    handleChangeZkjg(e) {
      for (let i of deepClone(this.checkRow.zxqk)) {
        if (e == i.id) {
          this.editResultFrom = i;
          this.editResultFrom.zkjgid = +e;
          this.editResultFrom.czqjg = i.zxjg;
          this.applyCheckFrom = i;
          this.applyCheckFrom.zkjgid = +e;
          this.applyCheckFrom.czqjg = i.zxjg;
          this.applyCheckFrom.fhcs = i.fhcs;
        }
      }
    },
    handleViewRz(row, item) {
      this.rzList = deepClone(row);
      this.viewItem = deepClone(item);
      this.viewItem.zlbz = this.replaceNewLineWithBR(this.viewItem.zlbz);
      this.viewItem.jcbz = this.replaceNewLineWithBR(this.viewItem.jcbz);
      this.viewItem.jmgz = this.replaceNewLineWithBR(this.viewItem.jmgz);
      this.logDialog = true;
    },

    downloadSvnFile(row) {
      console.log(row);
      const filePath = row.url;
      const fileName = row.wjmc;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      console.log(url);
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },

    handleExport() {
      this.$message({
        message: "努力导出中.....",
        type: "warning",
        duration: 0,
      });
      exportZkjgList({
        xmbh: this.xmbh,
        year: moment(this.xmSeleltParams.year).format("YYYY"),
      }).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
          this.$message.success("导出成功！");
          this.$message.closeAll();
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    getCgwListData(row) {
      this.cgwListDialog = true;
      getCgwList({
        xmbh: this.xmbh,
        year: moment(this.xmSeleltParams.year).format("YYYY"),
        zbid: row.zbid,
        zjmx: row.zjmxjdid,
      }).then((res) => {
        if (res.code == 0) {
          this.cgwList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleApplyCheck(row) {
      this.applyCheckDialog = true;
      this.checkRow = deepClone(row);
      let temp = [];
      let id = null;
      let zxjg = null;
      let zkjgid = null;
      for (let i of row.zxqk) {
        if (
          i.zxjg == 2 ||
          i.zxjg == 3 ||
          i.zxjg == 4 ||
          i.zxjg == 5 ||
          i.zxjg == 6
        ) {
          temp.push(i);
        }
        //是否当季、当半年 ，是,勾选此季度、半年度指标

        if (i.isdq == 1) {
          id = i.id;
          zxjg = i.zxjg;
          zkjgid = i.id;
        }
      }
      this.zkzbOption = temp;
      this.applyCheckFrom = { id, zkjgid, czqjg: zxjg };
      getJdspr({ zbid: row.zbid }).then((res) => {
        if (res.code == 0) {
          this.sprXm = res.data?.xm;
          this.sprId = res.data?.jdspr;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleViewCgw(row) {
      sessionStorage.setItem("previewurl", row.previewurl);
      let routeData = this.$router.resolve({
        path: "/officePreview",
        component: () => import("@/views/zxlc/officePreview/index"),
      });
      window.open(routeData.href, "_blank");
    },

    handleChangeFiles(file, fileList) {
      //验证上传文件的格式
      const suffixReg = /(pdf|ppt|pptx|docx|doc|png|jpg|bmp|xls|xlsx)$/;
      const point = file.name.lastIndexOf(".");
      const suffix = file.name.substr(point + 1);
      const isFile = suffixReg.test(suffix);
      if (!isFile) {
        this.$message.error("请上传正确格式的文件 !");
        fileList.pop();
        return false;
      }
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 20;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
    },
    handleExceed(file, fileList) {
      this.$message.error(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    handleSaveApply() {
      this.$refs["applyCheckFrom"].validate((valid) => {
        if (valid) {
          //   this.$refs.upload.submit();
          if (this.applyCheckFrom.fhcs >= 1) {
            this.$message.error(
              "每个指标结果只能申请1次复核，您已申请过此指标复核！"
            );
            return;
          }
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });
          form.append("db", "dn0");

          if (fileLen > 0) {
            //上传文件
            return new Promise((resolve, reject) => {
              uploadFile(form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("上传成功！");
                    this.applyCheckFrom.wjid = res.data;
                    this.handleInsertZkfh();
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            });
          } else {
            this.applyCheckFrom.wjid = "";
            this.handleInsertZkfh();
          }
        } else {
          //   this.$message.error("请输入表单必填字段！");
        }
      });
    },
    handleInsertZkfh() {
      const { wjid, sqsm, sqjg, zkjgid } = this.applyCheckFrom;
      insertZkfh({ wjid, sqsm, sqjg, zkjgid, shr: this.sprId }).then((res) => {
        if (res.code == 0) {
          this.applyCheckDialog = false;
          this.$message.success(res.msg);
          this.$refs.table1.scrollTop = this.scrollTopTable1;
          this.$refs.table2.scrollTop = this.scrollTopTable2;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getPlanListData(row) {
      getPlanList({
        year: moment(this.xmSeleltParams.year).format("YYYY"),
        xmbh: this.xmInfo.xmbh,
        zjmx: row.zjmxjdid,
      }).then((res) => {
        if (res.code == 0) {
          this.planList = res.data;
          this.planListDialog = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getSqlData(row) {
      this.sql_zbid = row.zbid;
      getTsZbDataList({
        year: moment(this.xmSeleltParams.year).format("YYYY"),
        xmbh: this.xmInfo.xmbh,
        zbid: row.zbid,
      }).then((res) => {
        if (res.code == 0) {
          this.sqlList = res.data;
          this.sqlDialog = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleToPlan(row) {
      if (row.id) {
        var dataUrl = `/projectPlan/plan/viewTask?planId=${row.id}&planName=${row.plan_name}&status=${row.status}`;
        var menuName = row.plan_name;
      } else {
        var dataUrl = "/projectPlan/plan/search";
        var menuName = "项目计划";
      }
      var dataIndex = 9901;
      var data = { dataIndex, dataUrl, menuName };
      // window.parent.menuItemInPage(dataUrl, dataIndex, menuName);
      window.parent.postMessage(data, "*");
    },
    handleScroll(e) {},
    changeTreeNodeStatus(node) {
      node.expanded = this.isExpand;
      for (let i = 0; i < node.childNodes.length; i++) {
        // 改变节点的自身expanded状态
        node.childNodes[i].expanded = false;
        // 遍历子节点
        if (node.childNodes[i].childNodes.length > 0) {
          this.changeTreeNodeStatus(node.childNodes[i]);
        }
      }
    },
    handleReset() {
      this.listQuery = {
        gzsj: "",
        zxjg: "",
        jcpl: "",
        zblx: "",
      };
    },
    handleClickGzl(row) {
      if (this.sql_zbid == 39 || this.sql_zbid == 46) {
        this.workDetailDialog = true;
        getRypzZbgzlDataList({
          taskid: row.taskid,
          ygbh: row.ygbh,
          year: row.year ? row.year : "",
          sjpl: row.sjpl ? row.sjpl : "",
        }).then((res) => {
          if (res.code == 0) {
            this.workDetailList = res.data;
          }
        });
      }
    },
    replaceNewLineWithBR(text) {
      if (text) {
        return text.replace(/\n/g, "<br>");
      } else {
        return text;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.app-container {
  min-height: 100%;
  min-width: 1200px;
  background-color: #eef2f8;
  padding: 10px;
  box-sizing: border-box;
  font-family: "Arial Negreta" !important;
  .project-info {
    width: 100%;
    max-height: 120px;
    position: relative;
    padding-left: 15px;
    border-bottom: 1px solid #efefef;
    .content {
      display: flex;
      padding: 0;
      min-height: 0;
      margin-top: 0;
      .acer {
        width: 100%;
        line-height: 22px;
        display: flex;
        .item {
          display: flex;
          flex-wrap: nowrap;
          margin-right: 22px;
          > div:nth-of-type(1) {
            font-size: 16px;
            font-weight: bold;
            padding-right: 8px;
            // min-width: 80px;
            box-sizing: border-box;
            position: relative;
          }

          > div:nth-of-type(2) {
            color: #787878;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 16px;
            color: #909399;
          }
        }
        .item:nth-last-child(1) {
          margin-right: 0;
        }
      }
    }
    .content::before {
      content: "";
      height: 100%;
      background: #036eb8;
      width: 4px;
      position: absolute;
      border-radius: 4px;
      left: 0;
      height: 22px;
    }
  }

  .middle {
    display: flex;
    .project-select {
      min-width: 230px;
      margin-right: 15px;
      overflow: auto;
      box-sizing: content-box;
      .content {
        width: 215px;
        margin-top: 15px;
      }
    }

    .result {
      width: calc(100% - 260px);
      .card-title {
        width: 150px;
      }
      .card-more {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 150px);
      }
    }
  }
}
.card {
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-sizing: border-box;
  .card-header {
    display: flex;
    justify-content: space-between;
    height: 22px;
    line-height: 22px;
    padding-bottom: 10px;
    border-bottom: 1px solid #efefef;
    .card-title {
      position: relative;
      font-size: 16px;
      font-weight: 700;
      > div {
        padding-left: 15px;
      }
    }
    .card-title::before {
      content: "";
      height: 100%;
      background: #036eb8;
      width: 4px;
      position: absolute;
      border-radius: 4px;
    }
    .card-more {
      color: #999;
      font-size: 13px;
      cursor: pointer;
    }
  }
}
.card-zdbj {
  margin-bottom: 0;
  .zdbj-check {
    margin-top: 15px;
    > div {
      line-height: 24px;
    }
  }
  .zdbj-btn {
    display: flex;
    justify-content: space-evenly;
    margin-top: 15px;
  }
}
.apply-check-card {
  border: 1px solid #efefef;
  padding: 15px;
}
.table_header {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    margin-left: 5px;
  }
}
.tree_child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.search-wrap {
  display: flex;
  justify-content: flex-end;
  > div {
    margin-left: 15px;
  }
  > div:nth-of-type(1) {
    margin-left: 0;
  }
}
.logDes {
  font-size: 15px;
  line-height: 22px;
  margin-bottom: 15px;
  div {
    margin-bottom: 10px;
  }
  span:nth-of-type(1) {
    color: #000;
    font-weight: 700;
  }
}
</style>
